document.addEventListener("DOMContentLoaded", function () {

  // Get ALL sliders on the page
  document.querySelectorAll(".pm-slider-wrapper").forEach(wrapper => {

    const slider = wrapper.querySelector(".pmSlider");
    const nextBtn = wrapper.querySelector(".pm-next");
    const prevBtn = wrapper.querySelector(".pm-prev");

    let slides = Array.from(slider.children);
    let index = 0;

    // Duplicate slides for loop
    slides.forEach(s => slider.appendChild(s.cloneNode(true)));
    slides = Array.from(slider.children);

    // Get width function
    function slideWidth() {
      return slides[0].offsetWidth + 25;
    }

    // Move function
    function moveSlider() {
      slider.style.transition = "transform 0.4s ease";
      slider.style.transform = `translateX(-${index * slideWidth()}px)`;
    }

    // Loop reset
    function resetLoop() {
      if (index >= slides.length / 2) {
        slider.style.transition = "none";
        index = 0;
        slider.style.transform = `translateX(0px)`;
      }
    }

    // Next button
    nextBtn.addEventListener("click", () => {
      index++;
      moveSlider();
      slider.addEventListener("transitionend", resetLoop, { once: true });
    });

    // Prev button
    prevBtn.addEventListener("click", () => {
      index--;
      if (index < 0) index = slides.length / 2 - 1;
      moveSlider();
    });

    // Autoplay (per slider instance)
    setInterval(() => {
      index++;
      moveSlider();
      slider.addEventListener("transitionend", resetLoop, { once: true });
    }, 3000);

    // Resize handler
    window.addEventListener("resize", () => {
      slider.style.transition = "none";
      slider.style.transform = `translateX(-${index * slideWidth()}px)`;
    });

  }); // END foreach

});